export default "__VITE_ASSET__BZImgNX___"